module.exports = __webpack_public_path__ + "img/130.88805251.png";